/// <reference path="../Modules/app.module.ts"/>

module App.Filters {
    export class TrustedHtml {
        static filterName: string = 'trustedHtml';

        constructor($sce: ng.ISCEService) {
            return (text) => {
                // Replace breaks text entered in a textarea with HTML-breaks.
                // Each browser could save breaks differently
                return $sce.trustAsHtml(text ? text.replace(/\n\r/g, "\n").replace(/\r\n/g, "\n").replace(/\n/g, "<br />").replace(/\r/g, "<br />") : text);
            };
        }
    }

    app.filter(TrustedHtml.filterName, (['$sce', ($sce) => new TrustedHtml($sce)]) as any);
    //app.filter(TrustedHtml.filterName, ['$sce', ($sce) => new TrustedHtml($sce)]);
}